import script from "./GeneralMapControls.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralMapControls.vue?vue&type=script&setup=true&lang=js"

import "./GeneralMapControls.vue?vue&type=style&index=0&id=bbefa412&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbefa412"]])

export default __exports__